import { ReactElement } from "react";
import { resolveProperty } from "@animech/axiom-utility";
import {
	FieldComponentBuilderArgs,
	FieldPipe,
	FieldPipeMeta,
	UiComponentBuildContext,
	UiComponentBuilder,
} from "@animech/axiom-ui-builder";
import { StockAwareThumbnailDropDown } from "../components/widgets/thumbnail-dropdown";
import { Root } from "@definitions";
import { ThumbnailDropDownNode } from "src/definitions/ui-definitions";

type ComponentBuilderArgs = FieldComponentBuilderArgs<
	Root,
	ThumbnailDropDownNode
>;

export class ThumbnailDropDownComponentBuilder
	implements UiComponentBuilder<Root, ThumbnailDropDownNode>
{
	private _args: ComponentBuilderArgs;

	constructor(args: ComponentBuilderArgs) {
		this._args = { ...args };
	}

	public build(
		node: ThumbnailDropDownNode,
		context: UiComponentBuildContext<Root>,
	) {
		const { getFieldNodeMeta, getFieldNodeValueMeta } = this._args;

		if (node.state) {
			const property = resolveProperty(node.state, context.activeProperty);
			return (
				<FieldPipe
					key={`${node.id}:${context.activeProperty}`}
					property={property}
					write
				>
					<FieldPipeMeta
						getFieldMeta={(property) => getFieldNodeMeta(node, property)}
						getFieldValueMeta={getFieldNodeValueMeta}
					>
						{this._render(node, context)}
					</FieldPipeMeta>
				</FieldPipe>
			);
		} else {
			return this._render(node, context);
		}
	}

	private _render(
		node: ThumbnailDropDownNode,
		_context: UiComponentBuildContext<Root>,
	): ReactElement {
		const { state, type, id, visible, ...props } = node;

		return <StockAwareThumbnailDropDown {...props} />;
	}
}
